import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';

import { ComparisonResponse, FetchComparisonParams } from './types';

const fetchComparison = async (params: FetchComparisonParams) => {
  const { data } = await api.get(`/spold/comparison`, { params });

  return data;
};

/**
 * The whole Impact Assessment comparison in one request — dataset headers, per-indicator scores and
 * their contributor breakdowns — replacing the 15-40+ calls the tab used to make.
 *
 * Each dataset carries its own version, so this deliberately takes no release from the route: a
 * comparison can span two of them, and every endpoint here would happily return HTTP 200 for the
 * wrong dataset if the release were inferred.
 */
const useComparison = (params?: FetchComparisonParams) =>
  useQuery<ComparisonResponse, AxiosError>({
    queryKey: ['comparison', params],
    queryFn: () => fetchComparison(params as FetchComparisonParams),
    enabled: Boolean(params),
    // Published releases don't change, so a pair's scores can't go stale. Without this every remount
    // refetches the whole payload — and a failed refetch sets isError over data that loaded fine.
    staleTime: Infinity,
  });

export default useComparison;
